
import Vue from "vue";
import store from "@/store";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default Vue.extend({
  name: "StatueHistoryComponent",
  mixins: [validationMixin],

  data() {
    return {
      defaultImage: require("@/assets/img/default-product.jpg"),
      url: "https://webapi.vip-chef.ir/images/landing/",
      dialog: false,
      selectedVideo: {
        title: "",
        _id: "",
      },
    };
  },

  computed: {
    videos() {
      return store.state.admin.landing.videos;
    },

    videoTitle: {
      get(): string {
        return store.state.admin.landing.potlidCategory.title;
      },
      set(value: string): void {
        store.dispatch("admin/updatePotlidTitle", value);
      },
    },

    videoTitleError(): string[] {
      const errors: string[] = [];
      if (!this.$v.videoTitle?.$dirty) {
        return errors;
      }
      !this.$v.videoTitle.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
  },

  methods: {
    banner(image: string) {
      if (image !== "") {
        return this.url + image;
      } else {
        return "";
      }
    },

    deleteStatue(id: string): void {
      store.dispatch("admin/deleteVideo", id);
    },

    openModal(box: any) {
      this.selectedVideo.title = box.title;
      this.selectedVideo._id = box._id;
      this.dialog = true;
    },

    submitEditTitle() {
      store.dispatch("admin/submitEditVideoTitle", this.selectedVideo);
    },
  },

  validations: {
    videoTitle: {
      required,
    },
  },

  created() {
    store.dispatch("admin/getLandingVideos");
  },
});
